import React, { Component } from "react";
import { connect } from "react-redux";
import { NewInventoryProduct } from "../../../../redux/actions/Modules.Action";
import ApiConnect from "../../../../Utils/ApiConnect";
import ProductAutoComplete from "../../SalesPurchase/Components/ProductAutoComplete";
import { toast } from "react-toastify";
class NewFormula extends Component {
  constructor() {
    super();
    this.state = {
      product: "",
      productID: "",
      prdQty: 0,
      prdUnit: "",
      tempMaterial: [],
      material: [],
      formError: false,
      btnDisable: false,
    };
  }
  componentDidMount() {
    this.fetchProducts();
  }
  fetchProducts() {
    ApiConnect.get("/Module/Inventory/Product/Details")
      .then((response) => {
        this.props.NewInventoryProduct(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }
  ProductChange = (e) => {
    this.setState({
      productID: e.id,
      product: e.name,
      prdQty: e.size,
      prdUnit: e.unit,
    });
  };
  MaterialAdded = (e) => {
    e.preventDefault();
    const newMat = this.state.material;
    newMat.push({ ...this.state.tempMaterial });
    this.setState({ material: newMat, tempMaterial: [] });
  };
  MaterialRemove = (e) => {
    const newMat = this.state.material;
    this.setState({ materials: newMat.splice(e, 1) });
  };
  handleChange = (e) => {
    const tempMat = { ...this.state.tempMaterial };
    if (e.target) {
      tempMat[e.target.name] = e.target.value;
    } else {
      tempMat["id"] = e.id;
      tempMat["name"] = e.name;
    }
    this.setState({ tempMaterial: tempMat });
  };
  handleFormPost = (e) => {
    e.preventDefault();
    let formData = new FormData();
    formData.append("product", this.state.product || ""); //append the values with key, value pair
    formData.append("productid", this.state.productID || "");
    formData.append("production", this.state.prdQty || "");
    formData.append("unit", this.state.prdUnit || "");
    this.state.material.forEach((x) => {
      formData.append("materials[]", x.id || "");
      formData.append("material_qty[]", x.qty || "");
      formData.append("material_unit[]", x.unit || "");
    });

    ApiConnect({
      method: "post",
      url: "/Module/Inventory/Consumption/Newformula",
      data: formData,
    })
      .then((response) => {
        this.setState({ btnDisable: false });
        if (response.data.status === 201) {
          toast.success(response.data.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            draggableDirection: "y",
          });
          this.setState({
            product: "",
            productID: "",
            prdQty: 0,
            prdUnit: "",
            tempMaterial: [],
            material: [],
            formError: false,
            btnDisable: false,
          });
        } else {
          this.setState({ formError: response.data.message });
        }
      })
      .catch((error) => console.log(error));
  };
  render() {
    return (
      <div className="container">
        <div className="col-md-12 col-xl-12">
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-6">
                  <div className="form-group">
                    <label>Product Name *</label>
                    {this.props.Products.length !== 0 ? (
                      <ProductAutoComplete
                        action={this.ProductChange}
                        styleName="form-control input-sm d-block"
                        name="product"
                        placeHolder="Product Name"
                        items={this.props.Products}
                      />
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div className="col-6 row">
                  <div className="form-group col-6">
                    <label>Production Qty*</label>
                    <input
                      type="number"
                      className="form-control"
                      readOnly
                      value={this.state.prdQty}
                    />
                  </div>
                  <div className="form-group col-6">
                    <label>Production Unit</label>
                    <input
                      type="text"
                      className="form-control"
                      readOnly
                      value={this.state.prdUnit}
                    />
                  </div>
                </div>
                <form onSubmit={(e) => this.MaterialAdded(e)}>
                  <table
                    className="table table-separated table-sm"
                    style={{
                      display: !this.state.productID ? "none" : "",
                    }}
                  >
                    <thead>
                      <tr>
                        <th classs="text-center">SN</th>
                        <th>Material</th>
                        <th>Qty</th>
                        <th>Unit</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td></td>
                        <td>
                          {" "}
                          {this.props.Products.length !== 0 ? (
                            <ProductAutoComplete
                              action={this.handleChange}
                              value={this.state.tempMaterial.name || ""}
                              styleName="form-control input-sm d-block"
                              name="product"
                              placeHolder="Material Name"
                              defaultValue={this.state.tempMaterial.name || ""}
                              items={this.props.Products}
                            />
                          ) : (
                            ""
                          )}
                        </td>
                        <td>
                          <input
                            type="number"
                            className="form-control"
                            name="qty"
                            value={this.state.tempMaterial.qty || ""}
                            onChange={(e) => this.handleChange(e)}
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            className="form-control"
                            name="unit"
                            value={this.state.tempMaterial.unit || ""}
                            onChange={(e) => this.handleChange(e)}
                          />
                        </td>
                        <td>
                          <button
                            type="submit"
                            className="btn btn-square btn-success text-center"
                          >
                            <span className="material-icons-outlined">add</span>
                          </button>
                        </td>
                      </tr>
                      {this.state.material.map((mat, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{mat.name}</td>
                          <td>{mat.qty}</td>
                          <td>{mat.unit}</td>
                          <td>
                            {" "}
                            <button
                              type="button"
                              className="btn btn-square btn-danger"
                              onClick={() => this.MaterialRemove(index)}
                            >
                              <span className="material-icons-outlined">
                                clear
                              </span>
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </form>
              </div>
            </div>
            <footer className="card-footer">
              <button
                className="btn btn-success w-100"
                type="button"
                disabled={this.state.btnDisable}
                onClick={(e) => this.handleFormPost(e)}
              >
                Submit Entries
              </button>
            </footer>
          </div>
        </div>
      </div>
    );
  }
}

export default connect((state) => ({ Products: state.Inventory.Products }), {
  NewInventoryProduct,
})(NewFormula);
